"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("../app/shared/lib/axios"));
class SessionRepository {
    static async addBanorteToSession(uuid, props) {
        const response = await axios_1.default.post(`/collections/identity/session/simulation/${uuid}`, props);
        if (response.status > 300) {
            throw new Error("(KLA4000) Algo salio mal");
        }
        return response.data;
    }
    static async addAbcToSession(uuid, props) {
        const response = await axios_1.default.post(`/collections/identity/session/simulation/${uuid}`, props);
        if (response.status > 300) {
            throw new Error("(KLA4000) Algo salio mal");
        }
        return response.data;
    }
}
exports.default = SessionRepository;
